
export default {
  props: {
    showPropertiesHolder: {
      type: Object,
      default: () => ({})
    },

    current: {
      type: Object,
      default: () => ({})
    },
    // 图表显示状态，查看，还是编辑  0 处于编辑状态  ， 1 处于展示状态
    type: Number,
  },

}
